module.exports = __webpack_public_path__ + "7c400a444be5ffd53f1310f9274ce024.svg";